// extracted by mini-css-extract-plugin
module.exports = {"TopButtons":"AllPurchasesView_TopButtons__1NGeO","TableContainer":"AllPurchasesView_TableContainer__3WgRh","SelectedRow":"AllPurchasesView_SelectedRow__3Hv4W"};